import { Box } from "@mui/material";
import { FC, useContext } from "react";
import { Outlet } from "react-router-dom";

import OverlayLoading from "./components/common/overlayLoading/OverlayLoading";
import LoadingContext from "./context/LoadingContext";

const App: FC = () => {
    const { loading } = useContext(LoadingContext);

    return (
        <>
            {
                loading ?
                    <OverlayLoading /> :
                    null
            }
            <Box sx={{ height: '100%', display: loading ? 'none' : 'block' }}>
                <Outlet />
            </Box>
        </>
    )
};

export default App;
